<div class="py-3">
    <!-- Fixed demo sidebar -->
    <fuse-vertical-navigation
        [appearance]="navigationAppearance"
        [navigation]="sidebarData"
        [inner]="true"
        [mode]="'side'"
        [name]="'demo-sidebar-navigation'"
        [opened]="true"
    ></fuse-vertical-navigation>
</div>
